export function getTrackingPagePreviewUrl(trackingPage) {
  if (trackingPage.hasZipCodeProtection) {
    return `${process.env.TRACKING_PAGE_URL}${trackingPage.hash}/<orderId>/<zipCode>`;
  }

  return `${process.env.TRACKING_PAGE_URL}${trackingPage.hash}/<orderId>`;
}